<template>
  <v-dialog v-model="show" overlay-color="darktext"
    overlay-opacity="0.6" max-width="600" scrollable>
    <v-card class="fill-height">
      <v-card-title>
        {{ $t('unsplashDialogTitle') }}
      </v-card-title>
      <v-card-text class="search-form" style="height: 70vh" >
        <v-text-field    
          type="text"
          :placeholder="$t('unsplashDialogPlaceholder')"
          v-model="searchText"
          @input="getSearchText"
          prepend-inner-icon="mdi-magnify"
          solo
          class="rounded-xxl"
          clearable
        />
        <div class="photos" v-if="photos.length && !loadingData">
          <div class="photo mb-4" v-for="photo in photos" :key="photo.id" style="position: relative;">
            <v-hover>
              <template v-slot:default="{ hover }">
                <div>
                  <v-img :src="photo.urls.thumb" :alt="photo.alt_description" width="100%" @click="applyPhoto(photo)" :style="{'cursor': 'pointer'}" data-testid="unsplash-photo"/>
                  <a :href="photo.user.links.html + '?utm_source=Skillboost&utm_medium=referral'" target="_blank" :style="{'opacity': hover ? '1' : '0'}" class="unsplash-user-link">{{ photo.user.first_name ? photo.user.first_name : '' + ' ' + photo.user.last_name ? photo.user.last_name : '' }}</a>  
                </div>
              </template>
            </v-hover>
          </div>
          <div
            v-observe-visibility="handleScrolledToBottom"
          />
        </div>
        <div v-if="notFound">
          {{ $t('unsplashNoResults') }}
        </div>
      </v-card-text>
      <v-card-text class="pa-4 text-right">
        {{ $t('unsplashPhotosFrom') }} <a href ="https://unsplash.com/?utm_source=Skillboost&utm_medium=referral" target="_blank">{{ $t('unsplash') }}</a>
      </v-card-text>
    </v-card>
   </v-dialog>
</template>
  <script>
  import { createApi } from 'unsplash-js';
  import _ from 'lodash'

  const unsplash = new createApi({
    accessKey: process.env.VUE_APP_UNSPLASH_ACCESS_KEY,
  });
  
  export default {
    props: {
      visible: Boolean
    },
    data() {
      return {
        photos: [],
        popularPhotos: [],
        currentPage: 1,
        searchText: '',
        pageNumber: 1,
        size: 30,
        lastPage: 1,
        notFound: false,
        loadingData: false
      };
    },
    computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.loadingCancel = true
          this.$emit('close')
        }
         
      }
    }
  },
  watch: {
    searchText(val) {
      if(val === '' || val === null){
        this.photos = this.popularPhotos
      }
    },
  },
  created(){
    this.loadingData = true
    //wait for img load
    setTimeout(() => {
      this.fetchPopularPhotos()
    }, 300);
    this.loadingData = false
  },
    methods: {
    getSearchText: _.debounce(
      function () {
        if(this.searchText != null && this.searchText != ''){

          this.doSearch();
        }
      },1000),
      async doSearch() {
        this.photos = [];
        this.pageNumber = 1
        await this.fetchPhotos()
      },
  
      async handleScrolledToBottom (isVisible) {
        if (!isVisible) {
          return
        }
        if (this.pageNumber >= this.lastPage) {
          return
        }
        this.pageNumber++
        this.fetchPhotos()
      },
      async fetchPhotos(){
          const result = await unsplash.search.getPhotos({
            query: this.searchText,
            perPage: this.size,
            page: this.pageNumber
          })
          if (result && result.status === 200) {
            if(result.response.total == 0){
              this.notFound = true
            }else{
              this.notFound = false
              this.photos.push(...result.response.results)
              this.lastPage = result.response.total_pages
            }
        }
      },
      async fetchPopularPhotos(){
        const result = await unsplash.photos.list({
          perPage: this.size,
          orderBy: 'popular'
        })
        if (result && result.status === 200) {
          this.popularPhotos = JSON.parse(JSON.stringify(result.response.results))
          this.photos = JSON.parse(JSON.stringify(result.response.results))
        }
      },
      async applyPhoto(photo){
        // trigger a download event
        await unsplash.photos.trackDownload({
          downloadLocation: photo.links.download_location
        });
        //embed cover image
        this.$emit('applyPhoto', photo)
      }
    },
  };
  </script>
  
  <style scoped>
.photos {
  column-count: 3;
}

@media screen and (min-width: 960px) {
  .photos {
    column-count: 4;
  }
}

.unsplash-user-link {
  background: rgba(0, 0, 0, 0.5);
    border-radius: 0 0 2px 2px;
    box-sizing: border-box;
    color: #FFFFFF;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    cursor: pointer;
    opacity: 0;
    overflow: hidden;
    padding: 2px 4px;
    position: absolute;
    text-decoration: underline;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    height: 20px;
    left: 0;
    bottom: 0;
}
</style>